<template>
  <article class="project-card">
    <div class="project-image" :class="tone">
      <div class="project-pattern"></div>
      <span class="project-tag">{{ category }}</span>
      <div class="project-graphic">
        <span v-for="n in 5" :key="n"></span>
      </div>
    </div>
    <div class="project-body">
      <div>
        <span class="project-location">{{ location }}</span>
        <h3>{{ title }}</h3>
      </div>
      <span class="project-arrow">↗</span>
    </div>
  </article>
</template>

<script>
export default {
  name: 'ProjectCard',
  props: {
    category: String,
    location: String,
    title: String,
    tone: { type: String, default: 'navy' }
  }
}
</script>